<template>
  <section @click="handleClick">
    <template v-if="keyAltDown">
      <el-tooltip
        placement="top-start"
        :visible-arrow="true">
        <div slot="content">{{hasCopy? 'Copied!' : 'Copy to Clipboard'}}</div>
        <span :class="className">
          <template v-if="text1">{{text1}}{{connector}}</template>
          {{text}}
        </span>
      </el-tooltip>
    </template>
    <template v-else>
      <span>
        <template v-if="text1">{{text1}}{{connector}}</template>
        {{text}}
      </span>
    </template>
  </section>
</template>

<script>
export default {
  name: 'AltCopy',
  props:{
    text:{
      type: [String, Number],
      default: ''
    },
    text1:{
      type: [String, Number],
      default: ''
    },
    className:{
      type: String,
      default: ''
    },
    key_value:{
      // 通过这个key和copykey来判断否需要更改hasCopy状态
      type: String,
      default: ''
    },
    copyKey:{
      type: String,
      default: ''
    },
    connector:{
      // text1和text之间的连接符
      type: String,
      default: ':'
    },
  },
  data () {
    return {
      keyAltDown: false,
      hasCopy: false
    }
  },
  watch:{
    copyKey:{
      immediate: true,
      handler(val){
        if(val != this.key_value){
          this.hasCopy = false
        }
      }
    }
  },
  created(){
    document.addEventListener('keydown', this.handleKeyDown)
    document.addEventListener('keyup', this.handleKeyUp)
  },
  methods: {
    handleClick(e){
      this.$emit('sendKey', this.key_value)
      if(this.keyAltDown){
        let el = e.target
        if(el.className.indexOf(this.className) != -1){
          // 复制内容到粘贴板
          let textarea = document.createElement('textarea')
          let txt = ''
          if(this.text1){
            txt = `${this.text1}${this.connector == ' '? '' : this.connector} ${this.text}`
          }else{
            txt = this.text
          }
          textarea.value = txt
          document.body.appendChild(textarea)
          textarea.select()
          document.execCommand('copy')
          document.body.removeChild(textarea)
          this.hasCopy = true
        }
      }
    },
    handleKeyDown(e){
      if(e.keyCode == 18){
        this.keyAltDown = true
      }
    },
    handleKeyUp(){
      this.keyAltDown = false
      this.hasCopy = false
    },
  },
}
</script>
<style lang='scss' scoped>
.key-alt-down{
  color: #0366D6;
  cursor: pointer;
}
</style>
<style lang="scss">
.el-tooltip__popper{
  color: red;
  .popper__arrow{
    left: 33.3px !important;
  }
}
</style>